import { Injectable }               from '@angular/core';
import { Globals }                  from '../common/globals';
import { HttpClient }               from '@angular/common/http';
import { Observable }               from 'rxjs';
import { CommonService }            from './common.service';

@Injectable()
export class WalletUpdateBatchService {

    private _commonService: CommonService;

    constructor(http: HttpClient, globals: Globals) {
        this._commonService = new CommonService(http, globals, 'walletUpdateBatch');
    }

    public getBatches(mediumID: number, page: number = 0, pageSize: number = 20, status?: number): Observable<any> {
        const params: any = { page, pageSize };
        if (status !== undefined) { params.status = status; }
        return this._commonService.get(`${mediumID}`, params);
    }

    public getBatch(batchID: number): Observable<any> {
        return this._commonService.get(`${batchID}`);
    }

    public createBatch(req: any): Observable<any> {
        return this._commonService.post('', req);
    }

    public deleteBatch(batchID: number): Observable<any> {
        return this._commonService.deleteItem(`${batchID}`);
    }
}
